// K+
import Constants from "../../api/Constants";

export default{
    name: "ImageBox",
    data(){
        return{

        }
    },
    props: {
        pid: {
            type: String
        },
        imagePath: {
            type: String
        },
        userLogged: {
            type: Boolean
        },
        selected: {
            type: Boolean
        },
        /**
         * allowed: 'chart', 'contest'
         */
        type: {
            type: String,
            default: 'contest'
        },
        ranking: {
            type: String
        },
        contestActive: {
            type: Boolean
        }
    },
    methods:{
        /**
         * Open modal receiving pathImage
         * @param {string} pathImage
         */
        openModal(pathImage){
            const dataModal = {
                isOpen: true,
                pathImage: pathImage
            };
            this.emitter.emit("toggle-modal", dataModal);
        },

        /**
         * Vote image
         * @param pid {string}
         * @param imagePath {string}
         */
        voteImage(pid, imagePath){
            /**
             * Redirect if user is not logged
             */
            if(!this.userLogged){
                window.location.href = "/login?urlBack=" + window.location.href.replace(window.location.origin, "") + "&regSource=" + Constants.PROMO_CODE;
                return false;
            }

            const dataImage = {
                pid: pid,
                pathImage: imagePath,
                vote: true
            };
            this.emitter.emit("vote", dataImage);
        }
    }
}
